import he from 'he';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import { cpdCategorysActions } from '../../../state/modules/areas-of-advice';
import { industryActions } from '../../../state/modules/industry';
import { publisherPortalActions } from '../../../state/modules/publisher-portal';
import ContentDetails from './../shared/publish-content/content-details';
import { systemStatusActions } from '../../../state/modules/system-status';
import FullScreenLoading from '../full-screen-loading';

const mapStateToProps = (state) => ({
  selectedContent: state.publisherPortal.content.selectedContent,
  contentQuestions: state.publisherPortal.content.contentQuestions,
  contentError: state.publisherPortal.content.error,
  libraryRouteRoot: routes.publisherPortal,
  isFetchingContent: state.publisherPortal.content.isFetching,
  includeTasa: true,
  choosePublisher: true,
  cpdCategorys: fp.map((aoa) => ({ ...aoa, name: he.decode(aoa.name) }))(
    state.cpdCategorys.cpdCategorys
  ),
  industriesWithCpdCategorys: state.industry.industriesWithCpdCategorys,
  isFetchingCpdCategorys: state.cpdCategorys.isFetching,
  isFetchingIndustries: state.industry.isFetchingIndustries,
  contentPassedUserEmails:
    state.publisherPortal.content.contentPassedUserEmails,
  systemProfile: state.systemStatus.profile
});

const mapDispatchToProps = (dispatch) => ({
  saveContent: bindActionCreators(
    publisherPortalActions.publisherPortal.content.saveContent,
    dispatch
  ),
  getContent: bindActionCreators(
    publisherPortalActions.publisherPortal.content.getById,
    dispatch
  ),
  resetSelectedContent: bindActionCreators(
    publisherPortalActions.publisherPortal.content.resetSelectedContent,
    dispatch
  ),
  getContentQuestions: bindActionCreators(
    publisherPortalActions.publisherPortal.content.getContentQuestions,
    dispatch
  ),
  getIndustriesWithCpdCategorys: bindActionCreators(
    industryActions.industries.industriesWithCpdCategorys,
    dispatch
  ),
  deleteContent: bindActionCreators(
    publisherPortalActions.publisherPortal.content.deleteContent,
    dispatch
  ),
  getCpdCategorys: bindActionCreators(
    cpdCategorysActions.cpdCategorys.get,
    dispatch
  ),
  getContentPassedUserEmails: bindActionCreators(
    publisherPortalActions.publisherPortal.content.getContentPassedUserEmails,
    dispatch
  ),
  getSystemProfile: bindActionCreators(
    systemStatusActions.systemStatus.profile,
    dispatch
  )
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.getSystemProfile();
      if (
        this.props.cpdCategorys.length === 0 &&
        !this.props.isFetchingCpdCategorys
      ) {
        this.props.getCpdCategorys();
      }

      if (
        this.props.industriesWithCpdCategorys.length === 0 &&
        !this.props.isFetchingIndustries
      ) {
        this.props.getIndustriesWithCpdCategorys();
      }
    }
  }),
  branch(
    ({ systemProfile }) => !systemProfile,
    renderComponent(FullScreenLoading)
  )
)(ContentDetails);



// WEBPACK FOOTER //
// ./src/containers/pages/publisher-portal/content-details.js